import { all, call, put, takeLatest } from 'redux-saga/effects';

import { request } from '@app/services';
import {
  getNewRecipes,
  getRecommendations,
  setNewRecipesFailed,
  setNewRecipesSuccess,
  setRecommendationsFailed,
  setRecommendationsSuccess,
} from './slice';

import * as endpoints from './endpoints';

function* getRecommendationsSaga(): any {
  try {
    const response = yield call(request.get, endpoints.getRecommendations);
    yield put(setRecommendationsSuccess(response.data));
  } catch (error: any) {
    yield put(setRecommendationsFailed(error));
  }
}

function* getNewRecipesSaga(): any {
  try {
    const response = yield call(request.get, endpoints.getNewRecipes);
    yield put(setNewRecipesSuccess(response.data));
  } catch (error: any) {
    yield put(setNewRecipesFailed(error));
  }
}

function* homeSagas() {
  yield all([takeLatest(getRecommendations, getRecommendationsSaga)]);
  yield all([takeLatest(getNewRecipes, getNewRecipesSaga)]);
}
export { homeSagas };
